module.exports = __webpack_public_path__ + "img/far_night_cyl75_axis0.f3e6116a.jpg";